<template>
  <div class="logotype">
    <Hero
      class="hero"
      heading="Logo"
    />

    <PageContainer>
        <BlockContainer>
          <BlockVisual
            :blockImage="'/logos/logo.svg'"
            :coloredBackground="'colored-background-secondary'"
          />
          <BlockText>
            <h2 class="block-header">The Main Logotype</h2>
            <p>The main logotype is the wordmark in orange.</p>
            <p>
              This logotype should be used on all correspondence
              and merchandise that doesn't use the orange background
              color. It must never be tweaked or scaled, and please
              don't use drop shadows, embossed or other digital effects.
              It's sacred.
            </p>
            <p><strong>And no. It can't be made red for an annual Christmas card.</strong></p>
            <DownloadButton url="https://seenthis-brand.s3.amazonaws.com/download/logos/logo.zip">Download Orange Logo</DownloadButton>
          </BlockText>
        </BlockContainer>

        <BlockContainer>
          <BlockText :sortOrder="'three'">
            <h2 class="block-header">The Secondary Logotype</h2>
          <p>
            The secondary logotype can be used on orange backgrounds
            or where the orange doesn't meet the standard. It comes in
            positive (black) and negative (white).
          </p>
          <DownloadButton url="https://seenthis-brand.s3.amazonaws.com/download/logos/logo-secondary.zip">Download Secondary Logo Pack</DownloadButton>
          </BlockText>
          <BlockVisual
            :blockImage="'/logos/logo-black.svg'"
          />
        </BlockContainer>

        <BlockContainer>
          <div class="clear-space-images">
            <img src="/images/vi/clear-space-1.svg" />
            <img src="/images/vi/clear-space-2.svg" />
          </div>
          <BlockText
            :coloredBackground="true"
          >
            <h2 class="block-header green-header">Clear Space</h2>
            <p>
              Always think about the logo as if it would be inside an invisible
              box. This box is the actual edge of the logotype and nothing
              should ever come inside the box. Fun game, huh? In fancy design lingo,
              this box is called “clear space”. It's based on the height of the
              wordmark logo. So if you are feeling unsure, just use the wordmark to be safe.
            </p>
            <p>
              Whenever you place the logotype in a document or on a Christmas card, <strong>be sure
              to play the imaginary box game</strong>. And remember that the clear space is your
              friend, so if you want even bigger space, that's not a problem at all.
            </p>
          </BlockText>
        </BlockContainer>

        <div class="centerText">
          <h2 class="block-header">Usage wordmark logotype</h2>
          <p>Below you find some examples of when to use what wordmark logotype.</p>
        </div>
        <BlockLogos>
          <div class="white"><img src="/logos/logo.svg"></div>
          <div class="black"><img src="/logos/logo.svg"></div>
          <div class="orange"><img src="/logos/logo-white.svg"></div>
          <div class="green30"><img src="/logos/logo.svg"></div>
          <div class="blue30"><img src="/logos/logo.svg"></div>
          <div class="secondary-color"><img src="/logos/logo.svg"></div>
          <div class="green"><img src="/logos/logo-white.svg"></div>
          <div class="blue"><img src="/logos/logo-white.svg"></div>
          <div class="orange"><img src="/logos/logo-white.svg"></div>
          <div class="green60"><img src="/logos/logo-black.svg"></div>
          <div class="blue60"><img src="/logos/logo-white.svg"></div>
          <div class="black"><img src="/logos/logo-white.svg"></div>
        </BlockLogos>
        <BlockLogos>
          <div class="bad-examples">
            <div class="green60">
              <div class="badUsage"></div>
              <img src="/logos/bad-logo-1.svg">
            </div>
            <p>Don't use the logotype in secondary colors</p>
          </div>
          <div class="bad-examples">
            <div class="blue30">
              <div class="badUsage"></div>
              <img src="/logos/bad-logo-2.svg">
            </div>
            <p>Don't invent your own colors (or let Microsoft help you)</p>
          </div>
          <div class="bad-examples">
            <div class="black">
              <div class="badUsage"></div>
              <img src="/logos/bad-logo-3.svg">
            </div>
            <p>Never put fancy effects like shadow or gradient on the logo</p>
          </div>
        </BlockLogos>
        <ViLinks />
    </PageContainer>
  </div>
</template>

<script>
import Hero from '../components/hero.vue';
import DownloadButton from '../components/download-button.vue';
import PageContainer from '../components/page-container.vue';
import BlockContainer from '../components/block-container.vue';
import BlockVisual from '../components/block-visual.vue';
import BlockText from '../components/block-text.vue';
import BlockLogos from '../components/block-logos.vue';
import ViLinks from '../components/visual-id-links.vue';

export default {
  name: 'Info',
  components: {
    Hero,
    DownloadButton,
    PageContainer,
    BlockContainer,
    BlockVisual,
    BlockText,
    BlockLogos,
    ViLinks,
  },
};
</script>


<style lang="stylus" scoped>
  @require '../style/colors'

  .clear-space-images
    display: flex
    flex-direction: column
    align-items: center
    row-gap: 7rem
    margin-bottom: 5rem

    @media only screen and (max-width: 850px)
      display: none

    img
      width: 100%

    img:last-of-type
      width: 50%

  .green-header
    color: $green

  .centerText
    margin: 100px 0 50px 0
    text-align: center

    p
      display: inline-block
      max-width: 350px
      text-align: left

  .white
    background-color: $white
    border: 1px solid #DADADA

  .black
    background-color: $black

  .orange
    background-color: $primary-color

  .green30
    background-color: $green30

  .blue30
    background-color: $blue30

  .secondary-color
    background-color: $secondary-color

  .green
    background-color: $green

  .blue
    background-color: $blue

  .green60
    background-color: $green60

  .blue60
    background-color: $blue60

</style>
